export const ENTITY = {
    JP:"jp"
}